import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import React, { useImperativeHandle } from 'react';
import { useIntendedHover } from 'palette/hooks/useIntendedHover';
import { Icon } from 'palette/Icon';
import { Typography, BodyText } from 'palette/Typography';
import './styles/MainHeaderNavBarItemContent.scss';

interface MenuItemProps {
    className?: string;
    label: string;
    isExternal: boolean;
    tag: string;
    tabIndex?: number;
    onMouseOver?: () => void;
    onFocus?: React.FocusEventHandler<HTMLDivElement>;
    ref?: React.RefObject<null>;
    isSelected: boolean;
}

function MainHeaderNavBarItemContent({
    label,
    tag,
    className,
    isExternal,
    tabIndex,
    onMouseOver,
    onFocus,
    isSelected,
}: MenuItemProps, ref:React.Ref<HTMLDivElement>) {
    const { intentRef } = useIntendedHover<HTMLDivElement>(onMouseOver);
    const [block, BEMElement] = BEMBlock('main-header-nav-bar-item-content');

    useImperativeHandle(ref, () => intentRef.current!, [intentRef]);

    return (
        <div
            ref={intentRef}
            className={classNames(block, className)}
            {...(tabIndex !== undefined) && { tabIndex }}
            onFocus={onFocus}
        >
            <BodyText
                color="regular"
                level="2"
                transform="capitalize"
                weight={isSelected ? 'bold' : 'regular'}
            >
                {label}
            </BodyText>
            {(isExternal || tag) && (
                <div className={BEMElement('decorators')}>
                    {tag && (
                        <Typography
                            className={BEMElement('tag')}
                            color="inherit"
                        >
                            {tag}
                        </Typography>
                    )}
                    {isExternal && (
                        <Icon
                            className={BEMElement('icon')}
                            name="palette_external_link"
                            size="x-small"
                        />
                    )}
                </div>
            )}
        </div>
    );
}

export default React.forwardRef(MainHeaderNavBarItemContent);
